import { z } from "zod";

export const sendEmailResponseSchema = z.object({
  result: z.boolean(),
  resultCode: z.string(),
});

export type SendEmailResponseType = z.infer<typeof sendEmailResponseSchema>;
